import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useNotification } from "~hooks/useNotification";
import { useApi } from "../../../shared/api";

export const useUpsertSeasonEntity = () => {
  const { sport, organizationId, seasonId, entityId } = useParams();
  const queryClient = useQueryClient();
  const { mutateData } = useApi();
  const { formatMessage } = useIntl();
  const notification = useNotification();
  return useMutation({
    mutationFn: async (data: any) => {
      return await mutateData({
        url: `${sport}/o/${organizationId}/seasons/${seasonId}/entities?include=seasons,entities,conferences,divisions`,
        method: "POST",
        data: data,
      });
    },
    onSuccess: async (response: any) => {
      if (response?.data && response.data.length > 0) {
        await queryClient.invalidateQueries({
          queryKey: ["seasonEntity", sport, organizationId, seasonId, entityId],
        });

        notification.success({
          message: formatMessage({ id: "entity.update.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
